export function getQueryParameter(key) {
  return getSearchParams().get(key);
}

export function getTabQueryParam(tabs, param) {
  const queryParam = getQueryParameter(param);

  if (Object.values(tabs).includes(queryParam)) {
    return queryParam;
  } else {
    return Object.keys(tabs)[0];
  }
}

export function setQueryParameter(key, value) {
  const params = getSearchParams();
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  const baseUrl = window.location.href.split('?')[0];
  window.history.pushState({}, '', baseUrl + '?' + params.toString());
}

// Reads a param and drops it, without adding a history entry: a flag spent the moment the page acts
// on it should not be there to act on again when the broker goes Back.
export function stripQueryParameter(key) {
  const params = getSearchParams();
  const value = params.get(key);
  params.delete(key);
  const query = params.toString();

  window.history.replaceState({}, '', `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`);

  return value;
}

function getSearchParams() {
  return new URLSearchParams(window.location.search);
}
